'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { Icon } from '@/components/Icon';

const SCROLL_THRESHOLD = 300;

export const ScrollToTop = () => {
  const t = useTranslations('common');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label={t('backToTop')}
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={classNames(
        'active:border-primary fixed right-4 bottom-24 z-[9999] flex h-13 w-13 items-center justify-center rounded-full border border-1 border-gray-200 bg-white drop-shadow-sm transition-all duration-200 lg:right-6 lg:bottom-36',
        isVisible
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0',
      )}
    >
      <Icon src="/icons/svg/chevron-up.svg" size={20} />
    </button>
  );
};
